<script lang="ts">
  import { beforeNavigate } from '$app/navigation';

  import { reveal } from 'svelte-reveal';

  import { Accordion } from '@shared/ui/accordion';
  import { Button } from '@shared/ui/buttons/button';

  import { PurchaseForm, type purchaseConfig } from '@features/purchase/purchase-form';

  import { titleTexts } from '../configs';
  import { purchaseRequestModel, requestAccordionActivity } from '../models';
  import { PurchaseRequestState } from '../types';
  import Success from './success.svelte';

  export let formData: purchaseConfig.PurchaseForm;
  export let formAction: string | undefined = undefined;

  $: isDefaultState = $purchaseRequestModel === PurchaseRequestState.Default;
  $: isSendRequestState = $purchaseRequestModel === PurchaseRequestState.SendRequest;
  $: isSuccessState = $purchaseRequestModel === PurchaseRequestState.Success;

  function handleSuccessSubmit() {
    purchaseRequestModel.set(PurchaseRequestState.Success);
  }

  function handleCancel() {
    requestAccordionActivity.show();
    purchaseRequestModel.set(PurchaseRequestState.Default);
  }

  beforeNavigate(() => {
    requestAccordionActivity.show();
    purchaseRequestModel.set(PurchaseRequestState.Default);
  });
</script>

<div
  class="shadow-custom dark:bg-alt-dark rounded-lg p-5"
  style="box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.35), 0px 2px 5px 0px rgba(0, 0, 0, 0.05), 0px 8px 40px 0px rgba(0, 0, 0, 0.05);"
>
  <p class="mb-5">
    {#if isDefaultState || isSendRequestState}
      {#key $purchaseRequestModel}
        {titleTexts[$purchaseRequestModel]}
      {/key}
    {/if}
  </p>

  <Accordion isOpen="{!$requestAccordionActivity && isSendRequestState}">
    <PurchaseForm
      {formData}
      {formAction}
      on:successSubmit="{handleSuccessSubmit}"
      on:cancel="{handleCancel}"
      isOpen="{!$requestAccordionActivity && isSendRequestState}"
    />
  </Accordion>

  {#if isSuccessState}
    <div use:reveal="{{ transition: 'fade', y: 0, duration: 350, delay: 250, opacity: 0 }}">
      <Success />
    </div>
  {/if}

  {#if isDefaultState}
    <div use:reveal="{{ transition: 'fade', y: 0, duration: 350, delay: 100, opacity: 0 }}">
      <Button
        on:click="{() => {
          purchaseRequestModel.set(PurchaseRequestState.SendRequest);
          requestAccordionActivity.close();
        }}"
      >
        Request to Purchase
      </Button>
    </div>
  {/if}
</div>

<style lang="scss">
  .shadow-custom {
    box-shadow:
      0px 0px 1px 0px rgba(0, 0, 0, 0.35),
      0px 2px 5px 0px rgba(0, 0, 0, 0.05),
      0px 8px 40px 0px rgba(0, 0, 0, 0.05);
  }
</style>
